import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ModalState, ModalStateType, OpenModalPayload } from "./types";

const initialState: ModalState = {
  isOpen: false,
  type: null,
  payload: {},
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ type: ModalStateType; data?: OpenModalPayload }>,
    ) => {
      state.isOpen = true;
      state.type = action.payload.type;
      state.payload = action.payload.data || {};
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.type = null;
      state.payload = {};
    },
    changeModal: (
      state,
      action: PayloadAction<{ type: ModalStateType; data?: OpenModalPayload }>,
    ) => {
      state.isOpen = true;
      state.type = action.payload.type;
      state.payload = action.payload.data || {};
    },
  },
});

export const { openModal, closeModal, changeModal } = modalSlice.actions;

export const modalWithStateSliceReducer = modalSlice.reducer;
